import React from 'react'

export interface ListStockItem {
    name?: string;
    qty?: number;
}

interface ListStockProps {
    title?: string;
    listDataStock: ListStockItem[];
}

const ListStock = ({ title, listDataStock }: ListStockProps) => {
    return (
        <article className='shadowCard bg-bg-grey-200 h-full p-3 w-full flex flex-col gap-3'>
            {title && <p className="text-text-blue-200 title3medium">{title}</p>}

            <div className="flex flex-col gap-3 h-full overflow-auto max-h-[200px]">
                {listDataStock.map((book, index) => (
                    <div key={index} className="flex flex-col w-full gap-4">
                        <div className="inline-flex items-center justify-between w-full gap-3 bg-white p-3 rounded-[12px]">
                            <div className="inline-flex items-center gap-3 min-w-0">
                                <div className="w-2 h-2 rounded-full overflow-hidden bg-[red] shrink-0"></div>
                                <span className="text-black title2medium truncate">{book.name}</span>
                            </div>
                            {book.qty && (
                                <span className=" reg12 truncate shrink-0 text-[#FC6605]">{book.qty} stock</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </article>
    )
}

export default ListStock